'use strict';

function MarkdownDirective($sanitize) {
  return {
    restrict: 'A',
    scope: {
      cnMarkdown: '='
    },

    link: function (scope, element) {
      element.html($sanitize(require('marked')(scope.cnMarkdown)));
    }
  };
}

module.exports = MarkdownDirective;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/directives/markdown/index.js
 ** module id = 22
 ** module chunks = 0
 **/